import React from 'react';
import Dialog from '@shared/ui/molecules/Dialog';
import './welcome-dialog.scss';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { useDispatch } from "react-redux";
import { closeFirstTimeView } from "../../store/auth.duck";
import { closeDialog } from '@shared/store/dialog.duck';
import { LinkButton } from '@shared/ui/atoms/buttons/LinkButton';
import { useTranslation } from "react-i18next";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function WelcomeDialog() {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const done = () => {
    dispatch(closeFirstTimeView());
    dispatch(closeDialog());
  }
  return (
    <Dialog isOpen={true}>
      <div>
        <img className="welcomeDialog__image" aria-hidden={true} src="/assets/images/welcome-image.svg" alt="welcome image" />

        <HeadlineMedium className="welcomeDialog__title">{t('onboarding.welcome')}</HeadlineMedium>
        <BodyRegular className="welcomeDialog__description">{t('onboarding.welcome-to-existing-company')}</BodyRegular>

        <LinkButton dataTest="welcome-got-it-btn"
                    className="welcomeDialog__button"
                    text="button.got-it"
                    fullWidth={true}
                    link="/whereabouts/team"
                    size={ButtonSize.Large}
                    onClick={() => done()} />
      </div>
    </Dialog>
  )
}
